<div class="item-container">
  @if(loading())
  {
    <splash></splash>
  } @else {
    @if(this.IsFound())
    {
      <Akte-Main [VersicherungsNr]="this.KVNummer()" ></Akte-Main>
    } @else {
      <div class="alert alert-danger alert view" role="alert">
        <h4 class="alert-heading">Unbekannt!</h4>
        <p>Zur Telefonnummer {{this.number}} konte keine Akte gefunden werden!</p>
      </div>
    }
  }
</div>
